import moment from 'moment-timezone';

import { constants as dateAndTimeConstants } from 'utils/dateAndTimes';

import { constants as addressesConstants } from 'utils/addresses';
import {
  getDayDiff,
  thresholdToRound,
} from 'utils/dateAndTimes/methods/methods';

// TODO move this keys!!
const getTimeKeyFull = (shipmentKey, key) => `shipment.${shipmentKey}.${key}`;
const getTimeKey = (stopType, timeParam) => `${stopType}_${timeParam}`;

const getDateKey = (stopType, timeParam) =>
  `${stopType}_date_${timeParam.split('_')[1]}`;
const getDateFromKey = (stopType) => `${stopType}_date_from`;
const getDateToKey = (stopType) => `${stopType}_date_to`;

const getDateKeys = (stopType) => [
  getDateFromKey(stopType),
  getDateToKey(stopType),
];

const getTimeKeysByStop = (stopType) => [
  `${stopType}_${dateAndTimeConstants.TIME_FIELD_PARAMS.from}`,
  `${stopType}_${dateAndTimeConstants.TIME_FIELD_PARAMS.to}`,
];

// TODO: make test
const getMinRounded = (
  dateTime,
  stepInMinutes = dateAndTimeConstants.CONSTANTS_FOR_RULES.STEPS_IN_MINUTES
) => {
  const baseDateTime = moment(dateTime).clone();
  const minutes = baseDateTime.minute();

  if (minutes <= stepInMinutes) {
    baseDateTime.minutes(minutes === 0 ? 0 : stepInMinutes);
  }
  if (minutes > thresholdToRound(stepInMinutes)) {
    baseDateTime.add(1, 'hours').minutes(0);
  }

  return baseDateTime;
};

// TODO: make test
const getMaxRounded = (
  dateTime,
  stepInMinutes = dateAndTimeConstants.CONSTANTS_FOR_RULES.STEPS_IN_MINUTES
) => {
  const baseDateTime = moment(dateTime).clone();

  const minutes = baseDateTime.minute();

  if (minutes > thresholdToRound(stepInMinutes)) {
    baseDateTime.minutes(thresholdToRound(stepInMinutes));
  }

  return baseDateTime;
};

// TODO: make test
const getHoursRangeByStepOfMinutes = ({
  fromDateTime,
  toDateTime,
  stepInMinutes = dateAndTimeConstants.CONSTANTS_FOR_RULES.STEPS_IN_MINUTES,
  diffDaysWithCurrentDate = 0,
}) => {
  const minDate = fromDateTime.clone().startOf('day');
  const ranges = [];

  const incrementTimeByStep = (step) => ({
    raw: fromDateTime.add(step, 'minutes').format('HH:mm'),
    diffDay: getDayDiff(minDate, fromDateTime),
  });

  ranges.push(incrementTimeByStep(0));
  let prevDiffDay = 0;

  do {
    const { raw, diffDay } = incrementTimeByStep(stepInMinutes);
    if (diffDay !== prevDiffDay) {
      ranges.push({ isSection: true, diffDays: diffDay });
      prevDiffDay = diffDay;
    }
    ranges.push({ raw, diffDay: diffDay + diffDaysWithCurrentDate });
  } while (fromDateTime.isBefore(toDateTime));

  return ranges;
};

const getAddressKey = (stopType) =>
  addressesConstants.ADDRESS_BY_STOP[stopType];
const getAddressRawKey = (stopType) =>
  `${addressesConstants.ADDRESS_BY_STOP[stopType]}_raw`;

export default {
  getTimeKeyFull,
  getTimeKey,
  getDateKey,
  getDateFromKey,
  getDateToKey,
  getDateKeys,
  getTimeKeysByStop,
  getMinRounded,
  getMaxRounded,
  getAddressKey,
  getAddressRawKey,
  getHoursRangeByStepOfMinutes,
};
